import { render, staticRenderFns } from "./CuratorUpdate.vue?vue&type=template&id=30a77678&scoped=true&"
import script from "./CuratorUpdate.vue?vue&type=script&lang=js&"
export * from "./CuratorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a77678",
  null
  
)

export default component.exports